<div class="auth-shell">
  <mat-card class="card-register auth-card">
    <h3 class="title">{{'signup' | traduccion}}</h3>
    <form class="register-form auth-form" [formGroup]="form" (ngSubmit)="signup()">
      <mat-form-field appearance="outline" class="auth-form-field">
        <mat-label>{{'tenantId' | traduccion}}</mat-label>
        <mat-icon matPrefix>apartment</mat-icon>
        <input
          matInput
          formControlName="tenantId"
          name="tenantId"
          type="number"
          min="1"
          autocomplete="off">
      </mat-form-field>
      <div *ngIf="tenantId.invalid && (tenantId.dirty || tenantId.touched)" class="text-danger">
        <small *ngIf="tenantId.errors.required">{{'tenantId.errors.required' | traduccion}}</small>
        <small *ngIf="tenantId.errors.min">{{'tenantId.errors.min' | traduccion}}</small>
      </div>

      <mat-form-field appearance="outline" class="auth-form-field">
        <mat-label>{{'email' | traduccion}}</mat-label>
        <mat-icon matPrefix>email</mat-icon>
        <input
          matInput
          formControlName="email"
          name="email"
          type="email"
          autocomplete="email">
      </mat-form-field>
      <div *ngIf="email.invalid && (email.dirty || email.touched)" class="text-danger">
        <small *ngIf="email.errors.required">{{'email.errors.required' | traduccion}}</small>
        <small *ngIf="email.errors.email">{{'email.errors.email' | traduccion}}</small>
      </div>

      <mat-form-field appearance="outline" class="auth-form-field">
        <mat-label>{{'password' | traduccion}}</mat-label>
        <mat-icon matPrefix>vpn_key</mat-icon>
        <input
          matInput
          formControlName="password"
          name="password"
          type="password"
          autocomplete="new-password">
      </mat-form-field>

      <div *ngIf="passwordStrength > 0" class="strength-bar">
        <div
          class="strength"
          [ngClass]="{
            'weak': passwordStrength <= 2,
            'medium': passwordStrength === 3 || passwordStrength === 4,
            'strong': passwordStrength === 5
          }"
          [style.width.%]="passwordStrength * 20">
        </div>
      </div>

      <p *ngIf="passwordStrength > 0" class="auth-strength-label">
        Fortaleza:
        <span class="auth-strength-badge" [ngClass]="{
          'badge-danger': passwordStrength <= 2,
          'badge-warning': passwordStrength === 3 || passwordStrength === 4,
          'badge-success': passwordStrength === 5
        }">
          {{ passwordStrength <= 2 ? 'Debil' : passwordStrength < 5 ? 'Media' : 'Fuerte' }}
        </span>
      </p>

      <div *ngIf="password?.touched && password?.invalid" class="text-danger">
        <small *ngIf="password.errors.required">{{'password.errors.required' | traduccion}}<br></small>
        <small *ngIf="password?.errors?.['minLength']">{{'password.errors.minlength' | traduccion}}<br></small>
        <small *ngIf="password?.errors?.['missingLowercase']">{{'password.errors.missingLowercase' | traduccion}}<br></small>
        <small *ngIf="password?.errors?.['missingUppercase']">{{'password.errors.missingUppercase' | traduccion}}<br></small>
        <small *ngIf="password?.errors?.['missingDigit']">{{'password.errors.missingDigit' | traduccion}}<br></small>
        <small *ngIf="password?.errors?.['missingSpecial']">{{'password.errors.missingSpecial' | traduccion}}<br></small>
      </div>

      <mat-form-field appearance="outline" class="auth-form-field">
        <mat-label>{{'passwordConfirm' | traduccion}}</mat-label>
        <mat-icon matPrefix>vpn_key</mat-icon>
        <input
          matInput
          formControlName="passwordConfirm"
          name="passwordConfirm"
          type="password"
          autocomplete="new-password">
      </mat-form-field>
      <div *ngIf="form.hasError('passwordMismatch') && form.get('passwordConfirm')?.touched" class="text-danger">
        <small>{{'password.errors.passwordNotMatch' | traduccion}}</small>
      </div>

      <button mat-stroked-button color="primary" type="submit" [disabled]="!form.valid" class="btn-round auth-submit">
        {{'signup' | traduccion}}
      </button>
    </form>

    <div class="forgot">
      <button mat-button type="button" (click)="_goTo('signin')" class="auth-link auth-link-primary">
        {{'do_have_account' | traduccion}}
      </button>
    </div>
    <div class="forgot">
      <button mat-button type="button" (click)="_goTo('reset')" class="auth-link btn-terciary">
        {{'forgot_password?' | traduccion}}
      </button>
    </div>
  </mat-card>
</div>
